import * as l from "react";
const a = (e) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 14H5V4h14v10h-6zm8-12H3a1 1 0 000 2v10a1 1 0 100 2h8v.38l-3.217 1.61-.019.01-4.076 2.04-.007.004-.122.061-.009.005a1 1 0 00.893 1.783l.007-.003 4.227-2.11.323-.162 2-.998V21a1 1 0 102 0v-2.38l2 .998.323.162 4.227 2.11.007.003a1 1 0 00.893-1.783l-.01-.005-.121-.06-.008-.004L16.236 18l-.018-.009L13 16.38V16h8a1 1 0 100-2V4a1 1 0 100-2zm-4.293 5.707a1 1 0 00-1.414-1.414L13.014 8.57l-2.464-.547a1 1 0 00-.867.217l-2.334 2a1 1 0 001.302 1.518l1.954-1.674 2.511.558a1 1 0 00.925-.27l2.666-2.666z",
      fill: "#2d6ded"
    }
  )
), t = a;
export {
  t as default
};
